import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-avaliacao-elegibilidade-admissao`

    return {
        index(queryParams = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParams)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParams = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParams)}`)
        },
        autocompletePaciente(queryParams = {}) {
            return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParams)}`)
        },
    }
}
